<template>    
    <v-badge color="#dd0000" >
      <template v-slot:badge v-if="hasFilter"> 
        <v-menu open-on-hover >
          <span slot="activator">{{nbFiltre}}</span>
          <v-list>
            <v-list-tile>
              <v-btn @click="resetFilter">{{$t('Admin.ResetFilterTooltip')}}<v-icon right>mdi-filter-remove</v-icon></v-btn>
            </v-list-tile>
          </v-list>
        </v-menu>
      </template>
      <v-icon>mdi-filter</v-icon>
    </v-badge>      
</template>
<script lang="ts" >
  import Vue from 'vue'
  import Component from 'vue-class-component'  
  import FleetFilter from '@/components/fleet/FleetFilter.vue'  
  import { FilterFleet } from '@/models/filter/FilterFleet'
  @Component({
    name: 'FleetFilterIcon',
      components: {FleetFilter}     
  })
  export default class FleetFilterIcon extends Vue {        
        
    get filterFleet(){
      return this.$store.myGetters.filterFleet
    }   

    get hasFilter() {
      return this.nbFiltre > 0
    }

    get nbFiltre(){
      return (this.filterFleet.search.length > 0?1:0)         
        + (this.filterFleet.onGoing?1:0) 
    }

    resetFilter() {
      this.$store.myActions.FLEET_RESET_FILTER()
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  
</style>
